import { Col, Row } from 'antd';
import { FORM_ERROR } from 'final-form';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';

import { addScale, NewScaleSubmitData } from '~src/modules/scales/actions/scaleActions';
import { ApiReduxResp } from '~src/services/apiMiddleware';
import logger from '~src/services/logger/LlsLogger';
import AddItemPageHeader from '~src/shared/headers/AddItemPageHeader';
import { PageContentContainer } from '~src/styles/containers.sc';

import ScaleAddForm from './ScaleAddForm';

interface DispatchProps {
  addScale(scale: NewScaleSubmitData): ApiReduxResp;
}

type Props = DispatchProps & RouteComponentProps<any> & WithTranslation;

class ScaleAdd extends React.Component<Props> {
  submitFrm = (scale: NewScaleSubmitData) =>
    this.props
      .addScale(scale)
      .then(({ error, response }) => {
        if (error) {
          return {
            name: error.response && error.response.data[0].translation_key,
            [FORM_ERROR]: 'add scale failed!',
          };
        } else if (response) {
          this.props.history.push(`/content/scales/${response.data.id}`);
        }
      })
      .catch(error => {
        logger.info('Error adding Scale', {
          error,
          info: {
            componentStack: 'ScaleAdd.jsx',
          },
        });
        throw error;
      });

  render() {
    const { t } = this.props;
    return (
      <PageContentContainer>
        <Row gutter={30}>
          <Col span={12} offset={6}>
            <AddItemPageHeader
              t={t}
              titleKey="x.scales.add.scale.title"
              subTitleKey="x.scales.add.scale.description"
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ScaleAddForm submitFrm={this.submitFrm} history={this.props.history} />
          </Col>
        </Row>
      </PageContentContainer>
    );
  }
}

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  addScale: scale => dispatch(addScale(scale)),
});

const ScaleAddT = withTranslation()(ScaleAdd);
const ScaleAddC = connect(null, mapDispatchToProps)(ScaleAddT);

export default ScaleAddC;
